import React from 'react'
import TeamPositions from '../positions/TeamPositions'
import { TeamsWithColours } from '../RoundResults'
import ResultsLineChart from './ResultsLineChart'
import { useResultsContext } from '../context/context'

interface Props {
  data: object[]
  teams: TeamsWithColours[]
  formatter?: (val: number) => string | number
  yAxisFormatter?: (val: number) => string | number
  maxYAxisvalue: number
  minYAxisvalue: number
  numberOfTicks: number
  teamPositions?: ModelAPI.Reporting.TeamPosition[]
  tooltipOrdering?: 'highest' | 'lowest'
}

const ResultsTeamLineChart: React.FC<Props> = ({
  data,
  teams,
  formatter,
  yAxisFormatter,
  maxYAxisvalue,
  minYAxisvalue,
  numberOfTicks,
  teamPositions,
  tooltipOrdering
}) => {
  const lines = teams.map((t) => ({
    name: t.teamName,
    key: `team${t.teamId}`,
    colour: t.colour
  }))

  const context = useResultsContext()
  return (
    <>
      <ResultsLineChart
        data={data}
        formatter={formatter}
        yAxisFormatter={yAxisFormatter}
        maxYAxisvalue={maxYAxisvalue}
        minYAxisvalue={minYAxisvalue}
        numberOfTicks={numberOfTicks}
        lines={lines}
        tooltipOrdering={tooltipOrdering}
      />
      {!context.hideTeamPositions && teamPositions && teamPositions.length > 0 && <TeamPositions teams={teams} teamPositions={teamPositions} />}
    </>
  )
}

export default ResultsTeamLineChart